import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.selectedBase, action) => {
  switch (action.type) {
    case types.SET_SELECTED_BASE: {
      return {
        selectedBase: action.selectedBase,
        selectedBaseNode: action.selectedBaseNode,
        selectedBaseGroup: action.selectedBaseGroup,
      };
    }
     
    default:
      return state;
  }
}
